<template>
  <div class="syllabusContainer">
    <div class="header">
      <div class="title">课程大纲-{{$route.query.courseName}}</div>
    </div>
    <div class="syllabusInfo">
      <div class="information">
        <div class="title"><div class="img"></div><span>基本信息</span><div class="img"></div></div>
        <div class="content">
          <div>
            <div>课程代码：{{couresInfo ? couresInfo.course.code : ''}}</div>
            <div>课程名称：{{couresInfo ? couresInfo.course.name : ''}}</div>
          </div>
          <!-- <div>英文名称：{{couresInfo.course.name}}</div> -->
          <div>
            <!-- <div>适用专业：{{couresInfo.course.name}}</div> -->
            <div>课程分类：{{couresInfo ? couresInfo.course.classificationName : ''}}</div>
          </div>
          <div>学时学分：{{couresInfo ? couresInfo.course.periodAndCredit : ''}}</div>
          <div>先修课程：{{couresInfo ? couresInfo.course.frontCourseName : ''}}</div>
        </div>
      </div>
      <!-- <div class="introduction">
        <div class="title"><img src="@/assets/dian-biaoti.png" alt=""><span>课程简介</span><img src="@/assets/dian-biaoti.png" alt=""></div>
        <div class="content">课程是中等职业学校计算机及应用专业的一门基础课程。其主要任务是使学生掌握必要的计算机硬件和软件知识，能够快速、准确的录入文字，掌握Windows操作系统和Office办公自动化及文字处理软件的应用，掌握因特网网络知识，为以后其他各专业课的学习打下基础。</div>
      </div> -->
      <div class="target">
        <div class="title"><div class="img"></div><span>课程目标</span><div class="img"></div></div>
        <div class="content" v-for="(item, index) in couresInfo.courseGoal" :key="index">
          {{(index + 1) + '. ' +  item.content}}
        </div>
      </div>
    </div>
    <back-to :path="backUrl"></back-to>
  </div>
</template>

<script>
import api from '@/api'
import backTo from '@/components/back'
export default {
  components: { backTo },
  data() {
    return {
      backUrl: '',
      couresInfo: ''
    }
  },
  created() {
    if(this.$route.query.from) {
      this.backUrl = '/courseSystem'
    } else {
      this.backUrl = '/indicatorPoints'
    }
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$post(api.syllabus.info(this.$route.query.courseId)).then(res => {
        this.couresInfo = res
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.syllabusContainer {
  background-color: #fff;
  .header {
    height: 150px;
    background-image: url('../../assets/bg-xiangqing-lv.png');
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    .title {
      font-size: 36px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      margin-top: 40px;
      letter-spacing: $letter-spacing;
    }
  }
  .syllabusInfo {
    position: absolute;
    top: 120px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    border-radius: 40px 40px 0px 0px;
    padding: 40px 47px 50px 50px;
    .title {
      text-align: center;
      margin-bottom: 52px;
      .img {
        width: 35px;
        display: inline-block;
        height: 20px;
        background-image: url('../../assets/dian-biaoti.png');
        background-size: 100% 100%;
      }
      span {
        margin: 0 19px;
        font-size:30px;
        color: #323232;
        font-weight: 700;
      }
    }
    .content {
      font-size:24px;
      color: #696969;
      line-height: 2;
    }
    .information {
      margin-bottom: 60px;
      .content {
        >div{
          &:first-of-type {
            display: flex;
            div {
              flex: 1;
              @include text-ellipsis();
            }
          }
          // &:nth-of-type(3) {
          //   display: flex;
          //   div {
          //     flex: 1;
          //   }
          // }
        }
      }
    }
    .introduction, .target {
      margin-bottom: 60px;
    }
  }
}
</style>